import { render } from "./tw-toast.vue?vue&type=template&id=5654eb79"
import script from "./tw-toast.vue?vue&type=script&lang=js"
export * from "./tw-toast.vue?vue&type=script&lang=js"
script.render = render

export default script